import { render } from "./NoticeBanner.vue?vue&type=template&id=45bcf524&scoped=true"
import script from "./NoticeBanner.vue?vue&type=script&lang=js"
export * from "./NoticeBanner.vue?vue&type=script&lang=js"

import "./NoticeBanner.vue?vue&type=style&index=0&id=45bcf524&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45bcf524"]])

export default __exports__